import {
  TextareaAutosize as MUITextArea,
  TextareaAutosizeProps,
} from "@mui/base";
import { styled } from '@mui/material';
import Typography from "../typography/typography";

interface TextAreaProps extends TextareaAutosizeProps {
  label?: string;
  error?: boolean;
  helperText?: string;
}

const TextArea = (props: TextAreaProps) => {
  const { placeholder, minRows = 3, label, helperText, error, ...rest } = props;

  const StyledTextArea = styled(MUITextArea)(({ theme: { palette } }) => ({
    "&": {
      padding: "0.4375rem 0.5rem",
      borderRadius: "0.25rem",
      borderColor: error
        ? palette.theme?.error[600]
        : palette.theme?.secondary[400],
      outline: "none",
      color: palette.theme?.secondary[800],
      fontSize: "0.875rem",
      "&::placeholder": {
        opacity: 1,
      },
      "&:hover": {
        borderColor: error
          ? palette.theme?.error[600]
          : palette.theme?.secondary[500],
      },
      "&:focus-visible": {
        borderWidth: "0.0625rem",
        borderStyle: "solid",
        borderColor: error
          ? palette.theme?.error[600]
          : palette.theme?.primary[700],
      },
      "&:disabled": {
        background: palette.theme?.secondary[200],
      },
    },
  }));

  return (
    <>
      <Typography
        type="s4"
        fontWeight={"medium"}
        mb={0.5}
        color={error ? "theme.error.600" : "theme.secondary.800"}
      >
        {label}
      </Typography>
      <StyledTextArea
        aria-label="minimum height"
        minRows={minRows}
        placeholder={placeholder}
        {...rest}
      />

      <Typography
        type="s4"
        fontWeight={"medium"}
        mt={-0.25}
        color={error ? "theme.error.600" : "theme.secondary.800"}
      >
        {helperText}
      </Typography>
    </>
  );
};
export { TextArea };
export default TextArea;
